/**
 * @generated SignedSource<<98dd106b1c6e85908a78853826a277d1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type headerMorningStudioArticle$data = {
  readonly coverDesktop: {
    readonly url: string;
  } | null | undefined;
  readonly coverMobile: {
    readonly url: string;
  } | null | undefined;
  readonly headline: string | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"articleSponsorContent" | "subheaderMorningStudioSubheaderContent">;
  readonly " $fragmentType": "headerMorningStudioArticle";
};
export type headerMorningStudioArticle$key = {
  readonly " $data"?: headerMorningStudioArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"headerMorningStudioArticle">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "url",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "headerMorningStudioArticle",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articleSponsorContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "subheaderMorningStudioSubheaderContent"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "headline",
      "storageKey": null
    },
    {
      "alias": "coverDesktop",
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "type": "COVER"
          }
        }
      ],
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "image",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": "image(filter:{\"type\":\"COVER\"})"
    },
    {
      "alias": "coverMobile",
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "type": "COVER_MOBILE"
          }
        }
      ],
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "image",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": "image(filter:{\"type\":\"COVER_MOBILE\"})"
    }
  ],
  "type": "Article",
  "abstractKey": null
};
})();

(node as any).hash = "8503d7552a4ce9536b102b67b98e3710";

export default node;
